import {
  array,
  enum_,
  number,
  object,
  optional,
  string,
  type InferOutput
} from 'valibot'

import {
  TOUR_IMPORT_JOB_STATUS_TYPE,
  TOUR_IMPORT_JOB_TYPE
} from '@/libs/api/types'

/**
 * 運行実績のインポート履歴の検索条件
 */
export const tourImportJobsSearchSchema = object({
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TOUR_IMPORT_JOB_STATUS_TYPE)),
  /** インポート種別 */
  type: optional(enum_(TOUR_IMPORT_JOB_TYPE)),
  /** 拠点ID */
  dcId: optional(number()),
  /** パートナーID */
  partnerIds: optional(array(number())),
  /** ファイル名 */
  fileName: optional(string())
})

export type TourImportJobsSearch = InferOutput<
  typeof tourImportJobsSearchSchema
>
